(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isManagedByGroup = false;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Check if managed by StickyGroupManager (set after manager initializes)
      // Use MutationObserver to detect when managedByGroup attribute is set
      this.checkManagedStatus();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      // Listen for sticky events from StickyGroupManager
      this.addEventListener('stickyHide', this.onManagedHide.bind(this));
      this.addEventListener('stickyReveal', this.onManagedReveal.bind(this));
      this.addEventListener('stickyReset', this.onManagedReset.bind(this));

      // Only attach scroll handler if not managed by group
      if (!this.isManagedByGroup) {
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
    }

    checkManagedStatus() {
      // Check if already managed
      if (this.dataset.managedByGroup === 'true') {
        this.isManagedByGroup = true;
        return;
      }

      // Watch for the attribute to be set by the manager
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'data-managed-by-group' && this.dataset.managedByGroup === 'true') {
            this.isManagedByGroup = true;
            // Remove scroll handler if it was attached
            if (this.onScrollHandler) {
              window.removeEventListener('scroll', this.onScrollHandler);
            }
            observer.disconnect();
          }
        });
      });

      observer.observe(this, { attributes: true });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // Skip if managed by group
      if (this.isManagedByGroup) return;

      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    // Event handlers for when managed by StickyGroupManager
    onManagedHide() {
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    onManagedReveal() {
      // Any reveal-specific logic
    }

    onManagedReset() {
      // Any reset-specific logic
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kyma-mix-match-bundle"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-kyma-mix-match-bundle]').forEach((root) => {
      const catalogNode = root.nextElementSibling;
      if (!catalogNode || !catalogNode.matches('[data-bundle-catalog]')) return;
      const catalog = JSON.parse(catalogNode.textContent);
      const primary = root.dataset.primary;
      const secondary = root.dataset.secondary;
      const tiers = [...root.querySelectorAll('[data-quantity]')];
      const slots = root.querySelector('[data-bundle-slots]');
      const total = root.querySelector('[data-bundle-total]');
      const cta = root.querySelector('[data-bundle-atc]');
      const form = root.querySelector('[data-bundle-form]');
      const status = root.querySelector('[data-bundle-status]');
      const sectionWrapper = root.closest('.shopify-section') || root.parentElement;
      const info = document.querySelector('[id^="ProductInfo-"]') || document.querySelector('.product__info-container');
      if (info && sectionWrapper && !info.contains(root)) info.append(sectionWrapper);
      let quantity = 1;
      let selected = [];
      const money = (cents) => new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(cents / 100);
      const getVariants = (handle) => catalog[handle] || [];
      const hasVariants = (handle) => getVariants(handle).length > 0;
      const swatchFor = (handle, value) => {
        const key = String(value || '').toLowerCase();
        const prefix = handle === root.dataset.maleHandle ? 'maleSwatch' : 'swatch';
        if (key.includes('rouge')) return root.dataset[`${prefix}Red`];
        if (key.includes('bleu') || key.includes('marine')) return root.dataset[`${prefix}Navy`];
        if (key.includes('noir')) return root.dataset[`${prefix}Black`];
        if (key.includes('beige')) return root.dataset[`${prefix}Beige`];
        return '';
      };
      const reset = () => {
        selected = Array.from({ length: quantity }, (_, index) => selected[index] || { handle: primary, variantId: null, color: null });
      };
      const button = (label, selectedValue, onClick) => {
        const el = document.createElement('button');
        el.type = 'button'; el.className = 'kyma-mix-match-bundle__option' + (selectedValue ? ' is-selected' : ''); el.textContent = label; el.addEventListener('click', onClick); return el;
      };
      const syncForm = () => {
        form.innerHTML = '';
        selected.forEach((item, index) => {
          if (!item.variantId) return;
          const id = document.createElement('input');
          id.type = 'hidden'; id.name = `items[${index}][id]`; id.value = String(item.variantId);
          const qty = document.createElement('input');
          qty.type = 'hidden'; qty.name = `items[${index}][quantity]`; qty.value = '1';
          form.append(id, qty);
        });
        root.dataset.bundlePayload = JSON.stringify({ items: selected.map((item) => ({ id: item.variantId, quantity: 1 })) });
      };
      const render = () => {
        reset(); slots.innerHTML = '';
        selected.forEach((item, index) => {
          const card = document.createElement('article'); card.className = 'kyma-mix-match-bundle__slot';
          const title = document.createElement('h3'); title.textContent = `${root.dataset.slotLabel} ${index + 1}`; card.append(title);
          const cut = document.createElement('div'); cut.className = 'kyma-mix-match-bundle__choice'; cut.innerHTML = '<span>Coupe</span>';
          const cutOptions = document.createElement('div'); cutOptions.className = 'kyma-mix-match-bundle__choices';
          [[primary, root.dataset.primaryLabel], [secondary, root.dataset.secondaryLabel]].forEach(([handle, label]) => {
            const el = button(label, item.handle === handle, () => { if (!hasVariants(handle)) return; item.handle = handle; item.variantId = null; item.color = null; render(); });
            el.disabled = !hasVariants(handle); cutOptions.append(el);
          });
          cut.append(cutOptions); card.append(cut);
          const variants = getVariants(item.handle);
          const current = variants.find((variant) => String(variant.id) === String(item.variantId)) || null;
          const colors = [...new Set(variants.map((variant) => variant.option1))];
          const selectedColor = item.color || current?.option1 || colors[0];
          const color = document.createElement('div'); color.className = 'kyma-mix-match-bundle__choice'; color.innerHTML = '<span>Couleur</span>';
          const colorOptions = document.createElement('div'); colorOptions.className = 'kyma-mix-match-bundle__choices';
          colors.forEach((value) => {
            const el = button(value, selectedColor === value, () => { item.variantId = null; item.color = value; render(); });
            const swatch = swatchFor(item.handle, value);
            if (swatch) {
              el.classList.add('kyma-mix-match-bundle__swatch');
              el.style.backgroundImage = `url("${swatch}")`;
              el.innerHTML = `<span>${value.replace(' réfléchissant', '')}</span>`;
              el.setAttribute('aria-label', value);
            }
            colorOptions.append(el);
          });
          color.append(colorOptions); card.append(color);
          const sizes = variants.filter((variant) => variant.option1 === selectedColor); const size = document.createElement('div'); size.className = 'kyma-mix-match-bundle__choice'; size.innerHTML = '<span>Taille à choisir</span>';
          const sizeOptions = document.createElement('div'); sizeOptions.className = 'kyma-mix-match-bundle__choices';
          sizes.forEach((variant) => { const el = button(variant.option2, String(variant.id) === String(current?.id), () => { item.color = selectedColor; item.variantId = variant.id; render(); }); el.disabled = !variant.available; sizeOptions.append(el); });
          size.append(sizeOptions); card.append(size); slots.append(card);
        });
        const tier = tiers.find((item) => Number(item.dataset.quantity) === quantity);
        total.textContent = money(Number(tier.dataset.total));
        syncForm();
        cta.disabled = selected.some((item) => !item.variantId || !getVariants(item.handle).find((variant) => String(variant.id) === String(item.variantId))?.available);
      };
      tiers.forEach((tier) => tier.addEventListener('click', () => { quantity = Number(tier.dataset.quantity); tiers.forEach((item) => { const active = item === tier; item.classList.toggle('is-selected', active); item.setAttribute('aria-checked', active); }); render(); }));
      cta.addEventListener('click', async () => {
        if (cta.disabled) return;
        cta.disabled = true;
        status.textContent = '';
        try {
          const response = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: root.dataset.bundlePayload });
          if (!response.ok) throw new Error('cart_add_failed');
          window.location.assign('/cart');
        } catch (_) { status.textContent = 'Impossible d’ajouter la sélection au panier. Réessayez.'; cta.disabled = false; }
      });
      render();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["valkental-bundle"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-valkental-bundle]').forEach((root) => {
      const catalogNode = root.nextElementSibling;
      if (!catalogNode || !catalogNode.matches('[data-bundle-catalog]')) return;
      const catalog = JSON.parse(catalogNode.textContent);
      const primary = root.dataset.primary;
      const secondary = root.dataset.secondary;
      const tiers = [...root.querySelectorAll('[data-quantity]')];
      const slots = root.querySelector('[data-bundle-slots]');
      const total = root.querySelector('[data-bundle-total]');
      const cta = root.querySelector('[data-bundle-atc]');
      let quantity = 1;
      let selected = [];
      const money = (cents) => new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(cents / 100);
      const getVariants = (handle) => catalog[handle] || [];
      const defaultVariant = (handle) => getVariants(handle).find((variant) => variant.available) || getVariants(handle)[0];
      const reset = () => {
        selected = Array.from({ length: quantity }, (_, index) => selected[index] || { handle: primary, variantId: defaultVariant(primary).id });
      };
      const button = (label, selectedValue, onClick) => {
        const el = document.createElement('button');
        el.type = 'button'; el.className = 'valkental-bundle__option' + (selectedValue ? ' is-selected' : ''); el.textContent = label; el.addEventListener('click', onClick); return el;
      };
      const render = () => {
        reset(); slots.innerHTML = '';
        selected.forEach((item, index) => {
          const card = document.createElement('article'); card.className = 'valkental-bundle__slot';
          const title = document.createElement('h3'); title.textContent = `Veste ${index + 1}`; card.append(title);
          const cut = document.createElement('div'); cut.className = 'valkental-bundle__choice'; cut.innerHTML = '<span>Coupe</span>';
          const cutOptions = document.createElement('div'); cutOptions.className = 'valkental-bundle__choices';
          [[primary, 'Femme'], [secondary, 'Homme']].forEach(([handle, label]) => cutOptions.append(button(label, item.handle === handle, () => { item.handle = handle; item.variantId = defaultVariant(handle).id; render(); })));
          cut.append(cutOptions); card.append(cut);
          const variants = getVariants(item.handle); const current = variants.find((variant) => String(variant.id) === String(item.variantId)) || defaultVariant(item.handle);
          const colors = [...new Set(variants.map((variant) => variant.option1))];
          const color = document.createElement('div'); color.className = 'valkental-bundle__choice'; color.innerHTML = '<span>Couleur</span>';
          const colorOptions = document.createElement('div'); colorOptions.className = 'valkental-bundle__choices';
          colors.forEach((value) => colorOptions.append(button(value, current.option1 === value, () => { const next = variants.find((variant) => variant.option1 === value && variant.available) || variants.find((variant) => variant.option1 === value); item.variantId = next.id; render(); })));
          color.append(colorOptions); card.append(color);
          const sizes = variants.filter((variant) => variant.option1 === current.option1); const size = document.createElement('div'); size.className = 'valkental-bundle__choice'; size.innerHTML = '<span>Taille</span>';
          const sizeOptions = document.createElement('div'); sizeOptions.className = 'valkental-bundle__choices';
          sizes.forEach((variant) => { const el = button(variant.option2, String(variant.id) === String(current.id), () => { item.variantId = variant.id; render(); }); el.disabled = !variant.available; sizeOptions.append(el); });
          size.append(sizeOptions); card.append(size); slots.append(card);
        });
        const tier = tiers.find((item) => Number(item.dataset.quantity) === quantity); total.textContent = money(Number(tier.dataset.total));
      };
      tiers.forEach((tier) => tier.addEventListener('click', () => { quantity = Number(tier.dataset.quantity); tiers.forEach((item) => { const active = item === tier; item.classList.toggle('is-selected', active); item.setAttribute('aria-checked', active); }); render(); }));
      cta.addEventListener('click', async () => {
        if (selected.some((item) => !item.variantId)) return;
        cta.disabled = true;
        try {
          const response = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: selected.map((item) => ({ id: item.variantId, quantity: 1 })) }) });
          if (!response.ok) throw new Error('cart_add_failed');
          window.location.assign('/cart');
        } catch (_) { cta.disabled = false; }
      });
      render();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
